import axiosInstance from '../services/AxiosInstance';

export function getPriceUnit(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`price-unit?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function deletePriceUnit(id) {
    return axiosInstance.delete(`price-unit/${id}`);
}

export function createPriceUnit(id) {
    return axiosInstance.post(`price-unit`,id);
}

export function updatePriceUnit(id, data) {
    return axiosInstance.put(`price-unit/${id}`,data);
}
